import {createContext, useContext} from 'react';

export type GoogleMapContextType = {
  maps?: any;
  geocode: any;
  places: any;
};

export const GoogleMapContext = createContext<GoogleMapContextType>(
  null as unknown as GoogleMapContextType
);

export function useGoogleMapContext(): GoogleMapContextType {
  return useContext<GoogleMapContextType>(GoogleMapContext);
}
